// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plus-minus-input-container {
  background: var(--ons-color-light);
  width: 100%;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -ms-user-select: none;
}
.plus-minus-input-container .plus-minus-input {
  background: var(--ons-color-primary-background);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  border-radius: 4px;
  width: 100%;
  position: relative;
}
.plus-minus-input-container .plus-minus-input ion-icon {
  position: absolute;
  font-size: 21px;
  min-width: 21px;
  cursor: pointer;
  transform: translateY(-50%);
  top: 50%;
  color: var(--ons-color-black-2);
}
.plus-minus-input-container .plus-minus-input ion-icon.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.plus-minus-input-container .plus-minus-input ion-icon.remove-circle {
  padding-right: 20px;
  left: 10px;
}
.plus-minus-input-container .plus-minus-input ion-icon.add-circle {
  padding-left: 20px;
  right: 10px;
}
.plus-minus-input-container .plus-minus-input .value {
  width: 100%;
}
.plus-minus-input-container .plus-minus-input .value input {
  width: 100%;
  text-align: center;
  background: transparent;
  border: none;
  color: var(--ons-color-black-2);
}
.plus-minus-input-container .plus-minus-input .value input:focus {
  outline: none;
}
.plus-minus-input-container.big .value {
  color: var(--ons-color-primary);
  font-size: 48px;
  font-family: var(--ons-font-bold);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/plus-minus-input/plus-minus-input.component.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;AACJ;AACI;EACI,+CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AACR;AACQ;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,QAAA;EACA,+BAAA;AACZ;AACY;EACI,YAAA;EACA,oBAAA;AAChB;AAEY;EACI,mBAAA;EACA,UAAA;AAAhB;AAEY;EACI,kBAAA;EACA,WAAA;AAAhB;AAIQ;EACI,WAAA;AAFZ;AAIY;EACI,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;AAFhB;AAIgB;EACI,aAAA;AAFpB;AASQ;EACI,+BAAA;EACA,eAAA;EACA,iCAAA;AAPZ","sourcesContent":[".plus-minus-input-container {\n    background: var(--ons-color-light);\n    width: 100%;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -webkit-touch-callout: none;\n    -ms-user-select: none;\n\n    .plus-minus-input {\n        background: var(--ons-color-primary-background);\n        padding: 10px 20px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        font-weight: 700;\n        font-size: 14px;\n        text-align: center;\n        border-radius: 4px;\n        width: 100%;\n        position: relative;\n\n        ion-icon {\n            position: absolute;\n            font-size: 21px;\n            min-width: 21px;\n            cursor: pointer;\n            transform: translateY(-50%);\n            top: 50%;\n            color: var(--ons-color-black-2);\n\n            &.disabled {\n                opacity: 0.5;\n                pointer-events: none;\n            }\n\n            &.remove-circle {\n                padding-right: 20px;\n                left: 10px;\n            }\n            &.add-circle {\n                padding-left: 20px;\n                right: 10px;\n            }\n        }\n\n        .value {\n            width: 100%;\n\n            input {\n                width: 100%;\n                text-align: center;\n                background: transparent;\n                border: none;\n                color: var(--ons-color-black-2);\n\n                &:focus {\n                    outline: none;\n                }\n            }\n        }\n    }\n\n    &.big {\n        .value {\n            color: var(--ons-color-primary);\n            font-size: 48px;\n            font-family: var(--ons-font-bold);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
